import {
  SubStepIconWrapper,
  StrikeThroughLine,
  SubStepContainer,
} from './atoms';
import { stepColorMap } from './utils';
import { StepState, StrikethroughLocation } from './types';
import styled from 'styled-components';
import { Paragraph } from '@ardoq/typography';

export type SubStepProps = {
  heading: string;
  state: StepState;
  isSelected?: boolean;
  isDisabled?: boolean;
  strikeThroughLocation?: StrikethroughLocation;
  onPress?: VoidFunction;
};

const DotIcon = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 50%;
`;

export function SubStep({
  heading,
  state,
  isSelected,
  isDisabled,
  onPress,
  strikeThroughLocation = 'both',
}: SubStepProps) {
  const focusState = isSelected ? 'selected' : 'initial';
  const isInteractive = Boolean(onPress);
  return (
    <>
      <SubStepContainer
        $borderColor={stepColorMap[state][focusState]}
        align="center"
        $isDisabled={isDisabled}
        $isSelected={isSelected}
        $isInteractive={isInteractive}
        $hasBorder={false}
        $rounded={true}
        onClick={() => !isDisabled && onPress?.()}
      >
        <StrikeThroughLine
          $location={strikeThroughLocation}
          $color={stepColorMap[state][focusState]}
        />
        <SubStepIconWrapper
          $color={stepColorMap[state][focusState]}
          $isFilled={focusState === 'selected'}
        >
          <DotIcon />
        </SubStepIconWrapper>
        <Paragraph variant="text2">{heading}</Paragraph>
      </SubStepContainer>
    </>
  );
}
